// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { type ItemPosition } from './types';

enum ItemRelativePosition {
	ITEM_IS_AFTER_VISIBLE_CARD = 1,
	ITEM_IS_BEFORE_VISIBLE_CARD = -1,
	ITEM_IS_VISIBLE_CARD = 0,
}

interface StyledCarouselItemProps {
	visiblePosition: ItemPosition;
	currentPosition: ItemPosition;
}

const getCurrentCardPosition = ({
	visiblePosition,
	currentPosition,
}: StyledCarouselItemProps): string => {
	const relativePosition = Math.sign(visiblePosition - currentPosition) || 0;
	switch (relativePosition) {
		case ItemRelativePosition.ITEM_IS_VISIBLE_CARD:
			return '0';
		case ItemRelativePosition.ITEM_IS_AFTER_VISIBLE_CARD:
			return '-100%';
		case ItemRelativePosition.ITEM_IS_BEFORE_VISIBLE_CARD:
		default:
			return '100%';
	}
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledCarouselSlide = styled.ul({
	position: 'relative',
	listStyle: 'none',
	margin: 0,
	padding: 0,
	display: 'flex',
	width: '100%',
	height: '100%',
	overflow: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const StyledCarouselItem = styled.li<{
	visiblePosition: ItemPosition;
	currentPosition: ItemPosition;
}>`
	position: absolute;
	top: 0;
	bottom: 0;
	padding: 0;
	margin: 0;
	width: 100%;
	transition: transform 0.365s ease-in-out;
	${(props: StyledCarouselItemProps) => {
		const cardPosition = getCurrentCardPosition(props);
		return `
            height: 100%;
            transform: translateX(${cardPosition});
        `;
	}}
`;
